module.exports = __webpack_public_path__ + "img/Family Playing.a57b665f.webp";